import React, { useState } from 'react';
import {Link} from 'react-router-dom'
import ModalRow from 'projects/components/ModalRow'
import dateMapper from 'mappers/DateMapper';
import { useUser } from 'hooks/users/queries';
import { CircularProgress } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const WRAP_STYLE = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};

function ChatRow(props) {

  const {project_id, id, name, created_at, onHide, user_id, onDelete, onConversationClick} = props;
  const [isDeleting, setIsDeleting] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const { data: user } = useUser(user_id, project_id);
  const user_name = user?.name || user?.email || null;
  const {dateString} = dateMapper(created_at);

  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowConfirm(true);
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDeleting(true);
    try {
      await onDelete(id);
    } catch (error) {
      console.error('Error deleting conversation:', error);
      setIsDeleting(false);
      setShowConfirm(false);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowConfirm(false);
  };

  const handleConversationClick = () => {
    if (onConversationClick) {
      onConversationClick(id);
    }
  };

  /*
    Open can be used to open the native file picker
  */
  return <ModalRow
      row={[
        <div
        style={WRAP_STYLE}
        className='chatRow'
        >
          {onConversationClick ? (
            <span
              onClick={handleConversationClick}
              style={{ cursor: 'pointer', color: '#1976d2' }}
            >
              {name}
            </span>
          ) : (
            <Link to={`/projects/${project_id}/chat/${id}`} onClick={onHide}>
              {name}
            </Link>
          )}
        </div>,
        <div style={WRAP_STYLE}>{user_name || '-'}</div>,
        <div style={WRAP_STYLE}>{dateString || '...'}</div>,
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px'
          }}
        >
          {isDeleting ? (
            <CircularProgress size={20} />
          ) : showConfirm ? (
            <>
              <span style={{ fontSize: '14px', color: '#666', marginRight: '4px' }}>Confirm?</span>
              <CheckIcon
                aria-label="confirm delete"
                onClick={handleConfirm}
                sx={{
                  fontSize: 20,
                  color: '#4caf50',
                  cursor: 'pointer',
                  '&:hover': { color: '#388e3c' }
                }}
              />
              <CloseIcon
                data-testid="CloseIcon"
                aria-label="cancel delete"
                onClick={handleCancel}
                sx={{
                  fontSize: 20,
                  color: '#f44336',
                  cursor: 'pointer',
                  '&:hover': { color: '#d32f2f' }
                }}
              />
            </>
          ) : (
            <DeleteOutlineIcon
              data-testid="DeleteOutlinedIcon"
              aria-label="delete conversation"
              onClick={handleDelete}
              sx={{
                fontSize: 18,
                color: '#666',
                cursor: 'pointer',
                '&:hover': { color: '#d32f2f' }
              }}
            />
          )}
        </div>
      ]}
    />
}


export default ChatRow
